import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef } from '@angular/material';
import messages from '../../messages';

export interface DialogData {
  titulo: string;
  mensagem: string;
  resposta?: string;
  data?: string;
  disabled: boolean;
}

@Component({
  selector: 'app-modal-confirmacao',
  templateUrl: './modal-confirmacao.component.html'
})
export class ModalConfirmacaoComponent {

  static readonly CONFIG: MatDialogConfig = {
    width: '400px',
    data: {
      mensagem: messages.find(message => message.id === 'MSG003').description
    }
  };

  constructor(
    public dialogRef: MatDialogRef<ModalConfirmacaoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
  }

}
